import { Flex } from "components/LEGACY/styled-components/Flex"
import PasswordResetForm from "components/utils/PasswordResetForm"
import PatternPageContainer from "components/utils/PatternPageContainer"
import getpackedLogo from "images/getpacked_Logo_schwarz.svg"
import Image from "next/image"
import Link from "next/link"
import React from "react"

const ResetPassword = () => {
  return (
    <>
      <style jsx>{`
        .container {
          display: grid;
          justify-items: center;
          position: relative;
          grid-gap: 10px;
        }
        .linkContainer {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
      `}</style>
      <PatternPageContainer light>
        <Flex style={{ height: "100%" }} justifyCenter alignCenter>
          <div className="container">
            <Image src={getpackedLogo} alt={"getpacked logo"} layout="fixed" />

            <h1 style={{ color: "black" }}>Passwort zurücksetzen</h1>
            <PasswordResetForm />
            <div className="linkContainer">
              <Link href="/login">Stattdessen anmelden</Link>
              <Link href="/signup">Account erstellen</Link>
            </div>

            <hr />
          </div>
        </Flex>
      </PatternPageContainer>
    </>
  )
}

export default ResetPassword
